import { createSlice } from '@reduxjs/toolkit';

interface InitialState {}

const initialState: InitialState = {};

export const supportSiteListSlice = createSlice({
  name: 'supportSiteList-page',
  initialState,
  reducers: {},
  extraReducers() {},
});

export default supportSiteListSlice.reducer;
